<template>
  <ModalDefault modal_id="voipModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                class_body=""
                :modal_header="getTranslations('expression_856')"
                footer=""
                icon="bx bx-phone-call mr-1">
    <div class="px-2 py-2 pb-2" slot="body">
      <div class="row">
        <div class="col-12 pt-4 text-center">
          <div class="pt-2">
            <div class="avatar_content d-block">
              <div style="width: 120px; height: 120px;"
                   class="pl-2 avatar">
                <img style="min-width: 120px;
                                 min-height: 120px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                     class="avatar-img mt-2"
                     :src="(me.voip.lead.avatar_url
                          ? me.voip.lead.avatar_url
                          : lead_avatar)"/>
                <span style="min-width: 120px;
                                 min-height: 120px;
                                 margin-left: -120px;
                                 z-index: 8;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;
                                 background-color: #eee;"
                      class="avatar-img mt-2">
                <i class="bx bx-loader-alt bx-spin" style="font-size: 2rem; color: #bfbfbf;"></i>
              </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 pt-0 pb-0 text-center">
          <div>
            <span style="font-size: 22px; color: #353535; position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 500">
              {{ me.voip.lead.name }}
            </span>
          </div>
        </div>
        <div class="col-12 pt-0 text-center">
          <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
            <i class="bx bx-mobile"></i>
            <span style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 500">
              {{ me.voip.lead.phone_hidden }}
            </span>
          </div>
        </div>
        <div v-if="me.voip.status === 1" class="col-12 pt-3 pb-4 text-center">
          <div class="animated--grow-in">
            <span class="h3 bx-flashing text-gray-700">{{ getTranslations('expression_306') }}</span>
          </div>
        </div>
        <div v-if="me.voip.status === 2" class="col-12 pt-3 pb-2 text-center">
          <div class="animated--grow-in">
            <small class="pb-1">
              {{ getTranslations('expression_305') }}
            </small>
            <p class="pt-1">
              <i class="bx bx-time mr-1"></i>
              <span class="bx-flashing">
                {{
                  me.voip.minutes.length === 1
                    ? `0${me.voip.minutes}`
                    : me.voip.minutes
                }}:{{
                  me.voip.seconds.length === 1
                    ? `0${me.voip.seconds}`
                    : me.voip.seconds
                }}
              </span>
            </p>
          </div>
        </div>
        <div class="col-12 pt-3 pb-5 text-center">
          <div v-if="me.voip.status === 0" class="animated--grow-in">
            <div class="btn btn-success border-0 shadow-sm rounded-0 px-4 py-3"
                 @click.prevent="startCall"
                 style="background-color: #05b173; font-family: 'Product Sans Medium Regular'">
              <i class="fa fa-phone-alt mr-2"></i> {{ getTranslations('expression_857') }}
            </div>
            <div class="pt-2">
              <small class="text-gray-500">
                {{ getTranslations('expression_858') }}
              </small>
            </div>
          </div>
          <div v-if="me.voip.status > 0" class="animated--grow-in">
            <div class="btn btn-success border-0 shadow-sm rounded-0 px-4 py-3"
                 @click.prevent="endCall"
                 style="background-color: #e52121; font-family: 'Product Sans Medium Regular'">
              <i class="fa fa-phone-slash mr-2"></i> {{ getTranslations('expression_307') }}
            </div>
            <div class="pt-2 cursor_pointer" v-if="me.voip.status === 2">
              <small @click.prevent="setMute(false)" v-if="me.voip.mute">
                <i class='bx bx-volume-mute pr-1'></i>
                <span>{{ getTranslations('expression_308') }}</span>
              </small>
              <small @click.prevent="setMute(true)" v-else>
                <i class='bx bx-volume-full pr-1'></i>
                <span>{{ getTranslations('expression_309') }}</span>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import lead_avatar from "../../assets/img/no-pic-user.png";
import {Actions, Config, Events} from "../../assets/js/api4com/verto/verto-gateway";
import Timer from "easytimer.js";

export default {
  name: "ModalVoIP",
  components: {
    ModalDefault
  },
  data() {
    return {
      lead_avatar: lead_avatar,
    }
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getLeadObject',
      'getChannelObject',
      'getChatTicketObject',
    ]),
  },
  methods: {
    startCall() {
      Config.start({
        agent: {login: `${this.getChannelObject('id', this.me.voip.lead.channel_id).integrations[10].data.branch}@appbee.api4com.com`, passwd: `${this.getChannelObject('id', this.me.voip.lead.channel_id).integrations[10].data.branch}`},
        wssAddress: "fs.api4com.com:8082",
        wsFallbackURL: ["fs.api4com.com:8082"],
        useIce: true,
        tag: "call"
      })
      const timer = new Timer();

      Events.handleWsState.on('wsState', state => {
        if (state === 'logged') this.me.voip.logged = true;
      })
      Events.handleCallState.on('OUTBOUND_ACTIVE', status => {
        this.me.voip.status = status ? 2 : 0;
        if (status) {
          this.me.voip.media = true;
          this.me.voip.status = 2;
          timer.reset();
          timer.start({precision: 'seconds'});
          timer.addEventListener('secondsUpdated', (e) => {
            this.me.voip.minutes = `${timer.getTimeValues().minutes}`;
            this.me.voip.seconds = `${timer.getTimeValues().seconds}`;
          });
        } else {
          this.me.voip.minutes = '00';
          this.me.voip.seconds = '00';
          this.me.voip.status = 0;
          timer.stop();
          if (this.me.voip.media) {
            this.sendVoip(`https://pbx.api4com.com/recordings/appbee.api4com.com/${this.getChannelObject('id', this.me.voip.lead.channel_id).integrations[10].data.branch}@appbee.api4com.com/${window.localStorage.getItem('callID')}.mp3`)
            this.me.voip.media = false;
          }
        }
      })
      this.me.voip.status = 1;
      setTimeout(() => {
        let phone = this.xeroxHelper(this.me.voip.lead.phone)
        phone = phone.slice(2).toString()
        if(phone.length === 10) {
          const phone_p1 = phone.slice(0, 2)
          const phone_p2 = phone.slice(2)
          phone = `${phone_p1}9${phone_p2}`
        }
        Actions.call(`${this.getChannelObject('id', this.me.voip.lead.channel_id).integrations[10].data.branch}`, `0${phone}`, {ticket: `axpto0001`});
      }, 200)
    },
    endCall() {
      Actions.hangup();
      if(this.me.voip.media) {
        this.sendVoip(`https://pbx.api4com.com/recordings/appbee.api4com.com/${this.getChannelObject('id', this.me.voip.lead.channel_id).integrations[10].data.branch}@appbee.api4com.com/${window.localStorage.getItem('callID')}.mp3`)
        this.me.voip.media = false;
      }
      Actions.logout();
      this.me.voip.status = 0;
    },
    setMute(payload) {
      this.me.voip.mute = payload;
      if (payload) {
        Actions.mute();
      } else {
        Actions.unmute();
      }
    },
    sendVoip(payload){
      this.$store.dispatch('sendMessage', {
        file: payload,
        text: "voip|",
        channel_id: this.me.voip.lead.channel_id,
        ticket_id: this.getChatTicketObject('lead_id', this.me.voip.lead.id).id,
        operator_id: this.isOperator(this.getChatTicketObject('lead_id', this.me.voip.lead.id).department_id),
        department_id: this.getChatTicketObject('lead_id', this.me.voip.lead.id).department_id,
      })
    },
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.me.voip.lead.channel_id)
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>

<style scoped>

</style>
